import { checkAxiosData, getAxiosConfig } from 'fe-common'
import { filter, tap, from } from 'rxjs'
import { handleMessages } from '../modules/client/utilities'

export default {
  namespaced: true,
  state: () => ({
    vips: []
  }),
  actions: {
    /**
     * response data:
     * [
     *  [
     *    {
     *      label: String,
     *      value: String,
     *      isHighLight: Boolean,
     *      tag: null || String
     *    },
     *    ...
     *  ],
     *  ...
     * ]
     * @param context
     * @param payload
     * @returns {Promise<AxiosResponse<any>>}
     */
    getVips(context, payload) {
      const { rootState, commit } = context
      commit('VIPS', [])

      return from(
        this.$axios.$post(
          `/webapi/index/getVipList?languageCode=${rootState.locale}&device=${
            !rootState.isMobile ? 'PC' : 'MOBILE'
          }`,
          {},
          getAxiosConfig(context)
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => commit('VIPS', data.vips || []))
        )
        .toPromise()
    }
  },
  mutations: {
    VIPS(state, payload) {
      state.vips = payload
    }
  },
  getters: {
    vips: state => state.vips
  }
}
